<script>
import Spinner from './Spinner.vue'

export default {
  components: { Spinner }
}
</script>

<template>
  <div class="full-screen-spinner">
    <Spinner />
  </div>
</template>

<style scoped lang="scss">
.full-screen-spinner {
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  opacity: 1;

  .loader {
    position: relative;
    top: 400px;
    height: 40px;
    width: 40px;
  }
}
</style>
